import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Experience } from '../components/Experience';
import { Projects } from '../components/Projects';
import { Contact } from '../components/Contact';
export function Portfolio() {
  return <div className="min-h-screen" data-id="element-129">
      <Hero data-id="element-130" />
      <About data-id="element-131" />
      <Experience data-id="element-132" />
      <Projects data-id="element-133" />
      <Contact data-id="element-134" />
    </div>;
}